export default "__VITE_ASSET__D_ZF9eWZ__"